import React, { useEffect, useState, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks'
import { apiSlice } from "../redux/api-slice";
import { useGetCategoriesQuery } from "../redux/api-category-slice";
import { updateFilter, removeFilter } from '../redux/filter/filter-slice'
import Category from './Category';
import { debounce, forEach } from 'lodash';
import { setCurrentPage, setPagination } from '../redux/settings/page-settings-slice';
import { LoadingSpinner } from '../common/loadingSpinner';
import { A11yDialog } from 'react-a11y-dialog';
import A11yDialogInstance from 'a11y-dialog';
import { SvgIcon } from '../../../ace/pages/calendar/components/svg-icon';
import { useMediaQuery } from 'react-responsive';
export default function Filters() {
    const { data = [], isFetching } = useGetCategoriesQuery(null);
    const [availableFilters, setAvailableFilters] = useState([]);
    const dispatch = useAppDispatch();
    const currentFilter = useAppSelector((state) => state.filterState.filters);
    const filterModal = useRef<A11yDialogInstance>();
    const belowLayoutBreakpoint = useMediaQuery({ query: `(max-width: ${1024}px)` });
    const modalClasses = {
        container: 'dialog-container ace-cal-filters-modal', overlay: 'dialog-overlay', dialog: 'ace-cal-filters-modal-content', title: 'h6-style', closeButton: 'modal-close ace-cal-filters-modal-close x-btn'
    };
    const updateCurrentFilter = e => {
        if (e.target.checked) {
            dispatch(updateFilter(e.target.id));
        }
        else {
            dispatch(removeFilter(e.target.id));
        }


        dispatch(apiSlice.util.resetApiState())
        dispatch(setCurrentPage(0));
        dispatch(setPagination(true));
    }

    const handleFiltersClick = () => {
        setFiltersOpen((isFiltersOpen) => !isFiltersOpen);
    }

    const updateFiltersBasedOnViewPort = () => {
        if (window.matchMedia("(max-width: 970px)").matches) {
            return false
        }
        return true;
    }
    const [isFiltersOpen, setFiltersOpen] = useState(updateFiltersBasedOnViewPort());

    window.addEventListener('resize', () => {
        if (updateFiltersBasedOnViewPort() === true) {
            setFiltersOpen(true)
        }
        else {
            setFiltersOpen(false)
        }
    });

    useEffect(() => {
        setAvailableFilters(data)
    }, [data.length, currentFilter]);


    return (
        <div className="otc-filters-container">
            {!belowLayoutBreakpoint &&
                <h3 className="h6-style">
                    Filter By Category
                </h3>
            }
            {belowLayoutBreakpoint &&
                <button type="button" className="btn-secondary btn-full-width-sm otc-filters-trigger" onClick={() => filterModal.current?.show()}>
                    <span>Filter By Category</span>
                    <SvgIcon iconId={"icon-filter"} cssClass={"svg-icon svg-icon-text"} />
                </button>
            }

            {isFetching ? <></> :
                <>
                    {availableFilters &&
                        <>
                            {data.length > 0 ?
                                <>
                                    {!belowLayoutBreakpoint &&
                                        <ul className="otc-filters space-top-md stack-md">

                                            {data && data.map(category => (
                                                <Category key={category.id} item={category} updateCurrentFilter={updateCurrentFilter} checked={currentFilter.includes(category.id.toString())} />
                                            ))}
                                        </ul>
                                    }{belowLayoutBreakpoint &&
                                        <A11yDialog
                                            id="filters_modal"
                                            title={"Filter By Category"}
                                            dialogRef={instance => (filterModal.current = (instance as A11yDialogInstance))}
                                            classNames={modalClasses}
                                            closeButtonLabel={"Close"}>
                                            <ul className="otc-filters space-top-md stack-md">

                                                {data && data.map(category => (
                                                    <Category key={category.id} item={category} updateCurrentFilter={updateCurrentFilter} checked={currentFilter.includes(category.id.toString())} />
                                                ))}
                                            </ul>

                                        </A11yDialog>
                                    }
                                </>
                                : <p className="space-top-lg"> No categories found. </p>
                            }
                        </>
                    }
                </>
            }

        </div>
    );
}



